export default "__VITE_ASSET___JqdWyw6__"